import { Injectable } from '@angular/core';


export class SimpleObject {
  value: number | string;

  name: string;

  icon?: string;

  badge?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileSelectorService {

  public profileSettings: SimpleObject[] = [
    { value: 1, name: 'Profilim', icon: 'accountbox' },
    { value: 2, name: 'Çıkış Yap', icon: 'arrowright' },
  ];

  public currentItem = "profile";

  
  getProfileSettings(): SimpleObject[] {
    return this.profileSettings;
  }


  getCurrentItem() {
    return this.currentItem;
  }

  getCurrentItemIcon() {
    const currentItem =
      this.currentItem === 'profile'
        ? 'accountbox'
        : 'arrowright';
    return currentItem;
  }

  
  switchItem(e: any) {
    this.currentItem = e;
  }

}
